import { useState } from 'react'

import { Banner, FormattedMessage } from '@b-stock/fe-core/bstock-react'

export const ContractInfoBanner = () => {
  const [isVisible, setIsVisible] = useState(true)

  return (
    isVisible && (
      <div data-testid="contract-info-banner">
        <Banner
          type="info"
          onDismiss={() => {
            setIsVisible(false)
          }}
        >
          <FormattedMessage id={`Auction.details.bid.contract.banner.info`} />
        </Banner>
      </div>
    )
  )
}
